import Vue from 'vue'
import App from './App.vue'
import Vant from 'vant';
import router from './router'
import 'vant/lib/index.css';
import "../src/assets/font.css";
Vue.use(Vant);
Vue.config.productionTip = false
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
